import React from "react";
import { waLink } from "@/data/site";
import { MessageCircle } from "lucide-react";

export function WhatsAppFloat() {
  return (
    <a
      href={waLink()}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float-cta"
      className="fixed bottom-5 right-5 z-40 group flex items-center gap-3 rounded-full bg-[#FFFBF5] border border-[#25D366]/30 shadow-[0_10px_40px_-12px_rgba(42,24,8,0.35)] pl-2 pr-4 py-2 transition-transform duration-300 hover:-translate-y-0.5"
    >
      <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#25D366] text-white">
        <MessageCircle size={20} />
      </span>
      <span className="hidden sm:block text-sm font-semibold text-[#2A1808] pr-1">Talk to a Travel Expert</span>
    </a>
  );
}
